import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-label tracking-wider uppercase border border-foreground-300/60 text-foreground-600 rounded-full mb-4">
            Browse Categories
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            Explore Every Category
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            From sneakers to accessories, every category is curated with the freshest finds from the Kakobuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-start p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg hover:bg-accent-50 hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
            >
              <span className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${cat.icon} text-lg text-secondary-700 group-hover:text-accent-700 transition-colors duration-300`}></i>
              </span>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap group-hover:text-accent-800 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="flex items-center gap-1.5 text-xs font-medium text-accent-600 group-hover:translate-x-1 transition-transform duration-200 whitespace-nowrap">
                Browse <i className="ri-arrow-right-line text-[10px]"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}